/* Reveal editorial content once. Product purchase controls stay immediately usable. */
(() => {
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const show = element => {
    element.classList.add('jm-visible');
    element.classList.remove('jm-pending');
  };
  const initialize = (root = document) => {
    const elements = root.querySelectorAll('.jm-reveal');
    if (media.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      elements.forEach(show);
      return;
    }
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.08, rootMargin: '0px 0px -36px 0px'});
    elements.forEach(element => {
      if (element.classList.contains('jm-visible')) return;
      element.classList.add('jm-pending');
      observer.observe(element);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.jm-reveal').forEach(element => observer?.unobserve(element));
  });
  media.addEventListener('change', () => {
    if (!media.matches) return;
    observer?.disconnect();
    document.querySelectorAll('.jm-reveal').forEach(show);
  });
  window.addEventListener('pageshow', () => initialize());
})();
